var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#322a7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-Icon-SVG-09856789",
    transform: "translate(-1516.251 -194.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile-Icon-SVG-09856789-2",
    "data-name": "Profile-Icon-SVG-09856789",
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    transform: "translate(1516.251 194.002)",
    fill: "#d2ebff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1516.251 194.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.416,
    cy: 1.416,
    r: 1.416,
    transform: "translate(22.276 14.259)",
    fill: "#f9ba8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.416,
    cy: 1.416,
    r: 1.416,
    transform: "translate(10.003 14.259)",
    fill: "#f9ba8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M20.373,33.1,17,29.049V25h6.747v4.049Z",
    transform: "translate(-2.896 -5.103)",
    fill: "#fcad6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M25.146,11.448c0-5.128-12.146-3.373-12.146,0v4.723a6.073,6.073,0,0,0,12.146,0Z",
    transform: "translate(-1.595 0.352)",
    fill: "#f9ba8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M18.747,4C14.632,4,12,7.306,12,11.422v1.55l1.349,1.147V10.747l8.1-2.7,2.7,2.7V14.12L25.5,12.973v-1.55c0-2.7-.675-5.4-4.049-6.073L20.772,4Z",
    transform: "translate(-1.27 1.727)",
    fill: "#35355e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M20.17,31h0a8.187,8.187,0,0,1-3.373.675A8.187,8.187,0,0,1,13.422,31S6,32.349,6,39.772L16.664,42.9l10.928-3.126C27.592,32.349,20.17,31,20.17,31Z",
    transform: "translate(0.682 -7.055)",
    fill: "#fff5ee"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6b2cae4bc3d0cb6799f3337d5c7310d2.svg";
export { ForwardRef as ReactComponent };